function ButtonParallax() {
  const groups = [...document.querySelectorAll('.button-parallax')];
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!groups.length || prefersReducedMotion.matches) {
    return;
  }

  let ticking = false;

  const update = () => {
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const viewportCenter = viewportHeight / 2;

    groups.forEach((group) => {
      const section = group.closest('section, [class*="__section"], main') || group.parentElement;

      if (!section) {
        return;
      }

      const rect = section.getBoundingClientRect();

      if (rect.bottom < 0 || rect.top > viewportHeight) {
        return;
      }

      const sectionCenter = rect.top + rect.height / 2;
      const distanceFromCenter = sectionCenter - viewportCenter;
      const offset = Math.max(Math.min(distanceFromCenter * -0.018, 10), -10);

      group.style.transform = `translate3d(0, ${offset.toFixed(2)}px, 0)`;
    });

    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(update);
  };

  update();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
}

export default ButtonParallax;
